export default {"src":"/_next/static/media/fierce.214100e6.svg","height":272,"width":645,"blurWidth":0,"blurHeight":0};